export interface BlogContentType {
    images: string;
    title: string;
    category: string;
}

const BlogContent: BlogContentType[] = [
    {
        images: '/assets/images/examples/studio-1.jpg',
        title: ' Getting tickets to the big show',
        category: 'Development'
    },
    {
        images: '/assets/images/examples/studio-4.jpg',
        title: 'A big ticket gone to be an interesting ',
        category: 'Management'
    },

    {
        images: '/assets/images/examples/studio-2.jpg',
        title: 'The Home of the Future Could Bebes',
        category: 'Design'
    },
    {
        images: '/assets/images/examples/studio-3.jpg',
        title: ' Getting tickets to the big show',
        category: 'Development'
    },
    {
        images: '/assets/images/examples/studio-5.jpg',
        title: 'A big ticket gone to be an interesting ',
        category: 'Management'
    },
    {
        images: '/assets/images/examples/studio-6.jpg',
        title: 'The Home of the Future Could Bebes',
        category: 'Design'
    },
]

export default BlogContent;